import { NgcCarIdentifier } from '~/app/utils/graphql-sub-types';

export function normalizeCarIdentifier(identifier: NgcCarIdentifier): NgcCarIdentifier {
	return {
		brand: identifier.brand,
		country: identifier.country,
		language: identifier.language,
		model: {
			code: identifier.model.code,
			extensions: identifier.model.extensions || [],
			version: identifier.model.version,
			year: identifier.model.year,
		},
		exteriorColor: identifier.exteriorColor,
		interiorColor: identifier.interiorColor,
		equipmentOptions: identifier.equipmentOptions || null,
	};
}
